var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasResults)?_c('div',[(_vm.value || _vm.value === 0)?_c('span',[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")]):_c('span',{staticClass:"text-muted"},[_vm._v("—")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }